import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImagProcessingService {

  public async generatePreviewUrls(files: File[]): Promise<string[]> {
    const previews: string[] = [];
    for (const file of files) {
      const result = await this.readFileAsDataURL(file);
      previews.push(result);
    }
    return previews;
  }

  public async resizeImage(file: File, maxSize: number): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject('Failed to get canvas context');
        return;
      }
      img.onload = () => {
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxSize) {
            height *= maxSize / width;
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width *= maxSize / height;
            height = maxSize;
          }
        }

        canvas.width = width;
        canvas.height = height;
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob((blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject('Failed to resize image');
          }
        }, 'image/jpeg', 0.6);
        URL.revokeObjectURL(img.src);
      };

      img.onerror = () => {
        reject('Failed to load image');
        URL.revokeObjectURL(img.src);
      };

      img.src = URL.createObjectURL(file);
    });
  }

  private readFileAsDataURL(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result as string);
        } else {
          reject('Error reading file');
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }
}
